import angular from 'angular';

import * as actions from '../../store/actions';

const mapStateToScope = (state) => ({});

angular
  .module('myConsultApp')
  .directive(
    'providerSearch',
    ($rootScope, $http, ENV, $ngRedux, $timeout) => {
      return {
        templateUrl: 'templates/v2/provider-search.html',
        restrict: 'E',
        scope: {
          onSelect: '&',
          onDeselect: '&',
          userZipCode: '=',
          preselected: '=',
        },
        link: ($scope, elem) => {
          $scope.organizationResults = null;
          $scope.numberOfResults = 0;
          $scope.lastSearchProviderInput = $scope.userZipCode ? $scope.userZipCode : '';
          $scope.showResultsHeader = false;
          $scope.loadMoreButton = false;
          $scope.organizationsMeta = null;
          $rootScope.loadProviderProcess = false;
          $scope.focusInput = true;
          $scope.deviceWidth = document.documentElement.clientWidth;
          $scope.scrollList = null;
          $scope.unsubscribe = $ngRedux.connect(mapStateToScope, actions)($scope);
          $scope.providersLoading = true;

          $scope.submitSearchProvider = function (searchProviderInput) {
            $scope.providersLoading = true;
            $scope.hideWhileLoading = true;
            $scope.searchProviderInput = searchProviderInput;
            $scope.lastsearchProviderInput = searchProviderInput;
            let address = {
              zipcode: $scope.searchProviderInput,
            };
            $scope.getGeoCode($http, ENV, address).then((geoCode) => {
              $timeout(() => {
                $scope.coordinatesCallback(geoCode);
              });
            });
          };

          $scope.coordinatesCallback = function (coord) {
            if (!$scope.searchProviderInput) {
              $scope.searchProviderInput = coord.city;
              if (coord.state && !$scope.userZipCode) {
                $scope.searchProviderInput = coord.city.concat(', ', coord.state);
                $scope.lastsearchProviderInput = $scope.searchProviderInput;
              }
            }
            var searchParm = {
              latitude: coord.latitude,
              longitude: coord.longitude,
              search: $scope.searchProviderInput,
              directory_type: 3,
            };

            $.each(searchParm, function (key, value) {
              if (!value) {
                delete searchParm[key];
              }
            });

            $scope.loadProviders(searchParm);
          };

          $scope.loadProviders = async (paramObj) => {
            $scope.searchOrganization($http, ENV, paramObj).then((response) => {
              $timeout(() => {
                $scope.numberOfResults = response.meta.count;
                $rootScope.loadProviderProcess = false;
                $scope.organizationResults = response.organizations;
                $scope.showResultsHeader = true;
                $scope.organizationsMeta = response.meta;
                $scope.providersLoading = false;
                $scope.hideWhileLoading = false;
                if ($scope.numberOfResults > 10) {
                  $scope.loadMoreButton = true;
                  $timeout(() => {
                    $scope.scrollList = $(elem).find('.results-scroll');
                    $scope.scrollMonitor();
                  });
                } else {
                  $scope.loadMoreButton = false;
                }
              });
            });
          };

          $scope.loadMoreProviders = function () {
            if ($scope.loadMoreButton && !$rootScope.loadProviderProcess) {
              $scope.searchOrganizationByUrl($http, $scope.organizationsMeta.next).then((response) => {
                $timeout(() => {
                  angular.forEach(response.organizations, function (value, key) {
                    $scope.organizationResults.push(value);
                  });
                  $scope.organizationsMeta = response.meta;
                  if (response.meta.next != null) {
                    $scope.loadMoreButton = true;
                  } else {
                    $scope.loadMoreButton = false;
                  }
                  $rootScope.loadProviderProcess = false;
                });
              });
            }
          };

          $scope.scrollMonitor = () => {
            $scope.scrollList.off('scroll').scroll(() => {
              const scroll = $scope.scrollList.scrollTop() + $scope.scrollList.outerHeight();
              const scrollHeight = $scope.scrollList[0] && $scope.scrollList[0].scrollHeight;
              if ($scope.loadMoreButton && scroll >= scrollHeight) {
                $scope.loadMoreProviders();
              }
            });
          };

          $scope.selectProvider = (provider) => {
            $scope.onSelect({ provider });
          };

          $scope.$watch('userZipCode', () => {
            if ($scope.userZipCode) {
              $scope.searchProviderInput = $scope.userZipCode;
              $scope.lastsearchProviderInput = $scope.userZipCode;
              $scope.submitSearchProvider($scope.userZipCode);
            }
          });
          $scope.providersLoading = true;
          $scope.hideWhileLoading = true;
        },
      };
    },
  );
